<div
  class="inline-job-loading state-loading"
  role="status"
  aria-live="polite"
  aria-busy="true"
>
  <div class="loading-container">
    <div class="loading-orb">
      <app-icon
        [name]="iconName"
        [size]="iconSize"
        [color]="iconColor"
      ></app-icon>
    </div>
    <h2 class="loading-title">{{ title }}</h2>
    <p class="loading-subtitle">{{ subtitle }}</p>
    @if (eta) {
      <p class="loading-eta"><app-job-eta [eta]="eta" /></p>
    }

    @if (progressMode === "indeterminate") {
      <div class="loading-progress">
        <div class="loading-bar">
          <div
            class="loading-bar-fill loading-bar-fill--indeterminate"
          ></div>
        </div>
      </div>
    } @else {
      <div class="loading-progress">
        @for (step of steps; track $index) {
          <div
            class="loading-step"
            [class.done]="step.done"
            [class.active]="step.active"
          >
            <div class="step-indicators">
              @if (step.done) {
                <app-icon name="check" [size]="10"></app-icon>
              }
            </div>
            <span class="step-text">{{ step.label }}</span>
          </div>
        }
        <div class="loading-bar">
          <div
            class="loading-bar-fill"
            [style.width.%]="barWidthPercent"
          ></div>
        </div>
      </div>
    }

    <div class="loading-cancel">
      <ng-content select="[jobCancel]"></ng-content>
    </div>
  </div>
</div>
